<template>
    <div class="">
      <!-- <titleArea :title="this.$t('menus.pa.chief_prosecutor.title1')" /> -->
      <AboutSection
        :image1="require('@/assets/AllSystem/kpk/image1.png')"
        :section1Title="$t('menus.sekretariati.about_us.section1.title')"
        :section1="$t('menus.sekretariati.about_us.section1.content')" />
    </div>
  </template>
  <script>  
  import AboutSection from '../share/AboutUs.vue'
  // import titleArea from '../../components/share/TitleArea.vue';

  export default {
    data(){
      return{
        
      }
    },
    components: {
      AboutSection,
      // titleArea
    },
  };
  </script>
  
  <style scoped>
  .textBox:first-child{
    border-right:4px solid #F5BD2A;
    padding-right:10px;
  }
  .textBox:nth-child(2){
    border-left:4px solid #F5BD2A;
    padding-left:10px;
  }
  </style>